import type { HTMLAttributes } from 'react'
import styled from 'styled-components'

import { TResponsiveProps, responsiveStyle } from '@hozana/styling/responsive'

const responsiveProps = { w: 'width', h: 'height' } as const

export type TAudioProps = HTMLAttributes<HTMLAudioElement> & TResponsiveProps<typeof responsiveProps>

export const Audio = styled.audio<TAudioProps>`
  max-height: 500px; // #iframeMaxHeight
  ${responsiveStyle(responsiveProps)}
`
